export const SILENT_HIGHLIGHT_MS = 2000

/**
 * Diff for silent list refresh: replace items and report ids that were not
 * in the previously saved list (by id only).
 */
export function silentListDiff(previousItems = [], nextItems = []) {
    const previousIds = new Set(previousItems.map((item) => item.id))
    const newIds = nextItems.filter((item) => !previousIds.has(item.id)).map((item) => item.id)

    return {
        items: nextItems,
        newIds,
        hasChanges: newIds.length > 0,
    }
}
